import { type UploadedImage } from '@/lib/types';
import { useContext } from 'react';
import UploadedImagesContext from '../UploadedImagesContext';
import ShouldGetImagesFromPublicApiContext from '../ShouldGetImagesFromPublicApiContext';
import useImageFileStatusRefreshing, {
  type ImageLocalStateUpdater,
} from '@/lib/files/useFileStatusRefreshing';

const useUploadedImageFileStatusRefreshing = (image: UploadedImage): void => {
  const { imagesEndpoint, updateImageInLocalState } = useContext(
    UploadedImagesContext,
  );

  const shouldGetImagesFromPublicApi = useContext(
    ShouldGetImagesFromPublicApiContext,
  );

  useImageFileStatusRefreshing(
    `${imagesEndpoint}/${image.id}/status${shouldGetImagesFromPublicApi ? '/public' : ''}`,
    image,
    (stateUpdater: ImageLocalStateUpdater): void => {
      updateImageInLocalState(image, stateUpdater);
    },
  );
};

export default useUploadedImageFileStatusRefreshing;
